import React from 'react'

const ContributorListSelector = (props) => {
    const { groups, onSelect } = props;
    return (
        <div className="btn-group mt-3" role="group">
            {groups.map(g => (
                <button key={g.id} onClick={() => onSelect(g.id)} type="button" className={`btn btn-${g.selected ? 'dark': 'secondary'}`}>{g.name}</button>
            ))}
        </div>
    )
}

export default ContributorListSelector